import { EntityCondition } from "../../entity/EntityCondition";

export class DtoConditionsPutRes extends EntityCondition {}
